import React from "react";
import { withTranslation } from "react-i18next";

class NotFound extends React.Component {
    render() {
        return (<>NotFound</>)
    }
}

export default withTranslation()(NotFound);